// extracted by mini-css-extract-plugin
export default {"buttonArea":"user_comn_buttonArea__EtoGj","titleArea":"user_comn_titleArea__D9dzB"};